import { BusinessKeywordsMapping } from 'api/client/mapping/business-keywords-mapping';
import { CountrySettings, GeneralCountriesApi, TravelQuestion } from 'api/general-countries';
import { CountriesClient, QuestionsClient } from 'api/swagger/ApiClient';
import { autoinject } from "aurelia-framework";
import { EssentialTypesMapping } from 'api/client/mapping/essential-types-mapping';

@autoinject
export class GeneralCountriesClientApi implements GeneralCountriesApi {
  constructor(private countriesClient: CountriesClient, private questionsClient: QuestionsClient, private essentialTypesMapping: EssentialTypesMapping, private businessKeywordsMapping: BusinessKeywordsMapping) { }

  async getCountrySettings(): Promise<CountrySettings[]> {
    return (await this.countriesClient.getAllActiveCountrySettingsInfoDTOs()).map(x => {
      return {
        id: x.id,
        approvalLevel: this.businessKeywordsMapping.mapToApprovalLevel(x.approvalLevel),
        approvalRequirementValue: x.approvalRequirement,
        approvalTypeValue: x.approveType,
        conditionMessage: x.specificCondition,
        approvers: x.approvers.map(a => this.essentialTypesMapping.mapSystemUserContactInfoToUserDetail(a)),
        questionIds: x.questions.map(q => q.id)
      }
    })
  }

  async getTravelQuestions(): Promise<TravelQuestion[]> {
    return (await this.questionsClient.getAllActiveKeywords()).map(x => {
      return {
        id: x.id,
        global: x.isGlobal,
        message: x.name,
        defaultChecked: x.isDefaultChecked,
        mandatory: x.isMandatory
      }
    })
  }
}
